import React from "react";
import Countdown from "react-countdown";
import { useSelector } from "react-redux";
import { toPersianNum, toSeperatedNum, shownText } from "../../assets/utils.js";
import { selectCurrentReqInfo } from "../../redux/currentReq/currentReq.selectors";
import { BtnStatus, Card } from "./ReqCard.styles";

const ReqCard = ({ reqInfo }) => {
  const {
    destination_location,
    source_location,
    vehicle_requested,
    load_type,
    loading_description,
    bit_count,
    bit_lowest_price,
    created_date_persian,
    status,
    status_persian,
    bitting_expires_at,
    candidated_driver,
    more_destinations,
  } = reqInfo;
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      // return <Completionist />;
      return <span className="small">به اتمام رسیده</span>;
    } else {
      // Render a countdown
      return (
        <span style={{ direction: "ltr" }}>
          {days ? <span className="">{toPersianNum(days)} | </span> : ""}
          {
            // toPersianNum(hours)}:{toPersianNum(minutes)}:{toPersianNum(seconds)
            toPersianNum(`${hours}:${minutes}:${seconds}`)
          }
        </span>
      );
    }
  };

  const chooseStatusPersian = () => {
    if (status === 0) {
      return (
        <div className="w-100 d-flex align-items-center justify-content-around">
          <span>زمان تا پایان</span>
          <Countdown date={new Date(bitting_expires_at)} renderer={renderer} />
        </div>
      );
    }
    if (status >= 1 || status === -1) return <span>{status_persian}</span>;
    // if (status === 1) {
    //   return (
    //     <div className="w-100 d-flex align-items-center justify-content-around">
    //       <span>زمان تا پایان</span>
    //       {/* <Countdown
    //         date={new Date(candidated_driver.deadline_to_confirm)}
    //         renderer={renderer}
    //       /> */}
    //     </div>
    //   );
    // }
  };
  // console.log(reqInfo);
  // debugger;
  // debugger;
  return (
    <Card href="#">
      {/* {console.log(destination_location)} */}
      <div>
        <h3 className="city-head d-inline">
          {source_location
            ? `${source_location._ostan.provincename}، ${source_location._shahr.shahrname}،`
            : null}
        </h3>
        <p className="city d-inline">
          {source_location ? shownText(source_location.detail) : null}
        </p>
      </div>
      {more_destinations && more_destinations.length > 0 ? (
        <div className="mt-2">
          <h3 className="city-head d-inline">چند مقصده</h3>
        </div>
      ) : (
        <div className="mt-2">
          <h3 className="city-head d-inline">
            {destination_location
              ? `${destination_location._ostan.provincename}، ${destination_location._shahr.shahrname}،`
              : null}
          </h3>
          <p className="city d-inline">
            {destination_location
              ? shownText(destination_location.detail)
              : null}
          </p>
        </div>
      )}
      <h5 className="req-type font-weight-bold d-flex align-items-center justify-content-center">
        {vehicle_requested ? vehicle_requested.v_name : null}
      </h5>

      <h4 className="load-type font-weight-bold">
        {load_type ? load_type.tname : null}
      </h4>

      <p className="load-desc">
        {loading_description ? loading_description : null}
      </p>

      <div className="custom-row">
        {bit_lowest_price === 0 ? null : (
          <div>
            <div className="opacity--5 font-size--n1">بهترین قیمت</div>
            <div>
              <span>{toSeperatedNum(toPersianNum(bit_lowest_price))}</span>

              <span> تومان</span>
            </div>
          </div>
        )}

        <div>
          <div className="opacity--5 font-size--n1">شرکت‌کنندگان</div>
          <div>
            <span>
              {bit_count ? toPersianNum(bit_count) : toPersianNum("0")}
            </span>

            <span> نفر</span>
          </div>
        </div>
        <div>
          <div className="text-center opacity--5 font-size--n1">
            {toPersianNum(created_date_persian)}
          </div>
        </div>
      </div>

      <BtnStatus status={status}>{chooseStatusPersian()}</BtnStatus>
    </Card>
  );
};

export default ReqCard;
